import { render, staticRenderFns } from "./linkMan.vue?vue&type=template&id=a1c32798&scoped=true"
import script from "./linkMan.vue?vue&type=script&lang=js"
export * from "./linkMan.vue?vue&type=script&lang=js"
import style0 from "./linkMan.vue?vue&type=style&index=0&id=a1c32798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c32798",
  null
  
)

export default component.exports